/**
 * OCHAT OVERLAY: recupera los namespaces que upstream traduce pero no carga.
 *
 * EL BUG DE UPSTREAM
 * `dashboard/i18n/locale/en/index.js` importa 42 namespaces.
 * `dashboard/i18n/locale/es/index.js` importa 37: le faltan `companies`,
 * `contentTemplates`, `mfa`, `snooze` y `yearInReview`. Los archivos JSON existen
 * y varios están traducidos por completo -- simplemente nunca se importan, así que
 * vue-i18n cae al inglés. Le pasa a TODOS los locales menos `en`, no solo al
 * español.
 *
 * Medido sobre esos cinco namespaces: 235 claves, de las cuales **94 ya están
 * traducidas al español** y hoy no se ven. `companies` (la sección Empresas del
 * menú) y `yearInReview` están traducidos al 100%.
 *
 * POR QUÉ SE ARREGLA ACÁ Y NO EN EL ARCHIVO DE UPSTREAM
 * `dashboard/i18n/locale/es/index.js` es un archivo que upstream edita en casi
 * cada release. Importar los JSON desde el overlay recupera las traducciones sin
 * tocarlo, y el día que upstream arregle su index esto se vuelve redundante en vez
 * de conflictivo.
 *
 * Se importan los JSON **de upstream**, sin copiar contenido: lo que falte
 * traducir se traduce en el archivo del overlay que corresponda, no acá.
 *
 * `snooze` no está en esta lista a propósito: su vocabulario vive completo en
 * ./snooze.json, porque el de upstream tiene un error de contenido
 * ("YEAR": "mes") y porque el spread de ../index.js es plano, así que un override
 * parcial reemplazaría el namespace entero.
 */
import companies from 'dashboard/i18n/locale/es/companies.json';
import contentTemplates from 'dashboard/i18n/locale/es/contentTemplates.json';
import mfa from 'dashboard/i18n/locale/es/mfa.json';
import yearInReview from 'dashboard/i18n/locale/es/yearInReview.json';

export default {
  ...companies,
  ...contentTemplates,
  ...mfa,
  ...yearInReview,
};
